"use strict";

exports.__esModule = true;
exports.StyledErrorCard = exports.LinkButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _breakpoints = require("../../../helpers/breakpoints");

var _LinkButton = _interopRequireDefault(require("../../navigation/LinkButton/LinkButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledErrorCard = _styledComponents.default.div`
    display: block;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 100px;
    text-align: center;
    color: ${({
  theme
}) => theme.colors.errorCard.text};
    background-color: ${({
  theme
}) => theme.colors.errorCard.background};
    border: 1px solid ${({
  theme
}) => theme.colors.errorCard.border};
    padding: 45px;
    border-radius: 4px;

    ${_breakpoints.breakpointUp.lg`
        padding: 60px;
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.StyledErrorCard = StyledErrorCard;
const LinkButton = (0, _styledComponents.default)(_LinkButton.default)`
    width: auto;
    min-width: 150px;
    margin: 40px 0 0 0;

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.LinkButton = LinkButton;